/** Mirrors `Travel_Marketplace-ui-updation/lib/utils/constants/app_constants.dart` for consistent contact forms. */

export const CONTACT_VERTICAL_OPTIONS = [
  "Airlines",
  "Hotels",
  "DMC",
  "Cruise Line",
  "Tour Operator",
  "Transfer",
  "OTA",
  "Other",
] as const;

export const CONTACT_ORG_TYPE_OPTIONS = [
  "Airline",
  "Hotel",
  "DMC",
  "Tour Operator",
  "Travel Agent",
  "Cruise Line",
  "Transfer Company",
  "OTA",
  "Other",
] as const;

/** level → label */
export const CONTACT_HIERARCHY_LEVELS: Record<number, string> = {
  0: "Company / Head Office",
  1: "VP / National Head",
  2: "Regional Head",
  3: "Area Manager",
  4: "Executive / Field Staff",
};

export function hierarchyLevelSelectOptions(): string[] {
  return Object.entries(CONTACT_HIERARCHY_LEVELS).map(([k, v]) => `${k}: ${v}`);
}
